import {
  Box,
  CircularProgress,
  Collapse,
  FormControlLabel,
  LinearProgress,
  Modal,
  Radio,
  RadioGroup,
} from "@mui/material";
import { RxCross1 } from "react-icons/rx";
import { FaChevronDown, FaChevronRight, FaChevronUp } from "react-icons/fa";
import OlinLogo from "../../../../assets/icons/olinlogo.png";
import { useEffect, useMemo, useState } from "react";
import { cloneDeep } from "lodash";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getCreditCardPlan,
  getCreditCardPlanPbf,
} from "../../../../services/purchaseApi";
import { useNavigate } from "react-router-dom";
import { getUrlActivatePaylater } from "../../../../services/olinAmanah";
import LoadingBackdrop from "../../../common/particles.jsx/LoadingBackdrop";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const ModalPaymentOption = ({
  grandTotal,
  subTotal,
  dataPaymentMethod,
  isFetchingPaymentMethod,
  open,
  setOpen,
  selected,
  setSelected,
  creditDetail,
  setCreditDetail,
  foundPayment,
}) => {
  const navigate = useNavigate();
  const [collapseArr, setCollapseArr] = useState(null);

  const handleClose = () => {
    setOpen(false);
  };

  const getPaymentCategory = (key) => {
    if (!key || key === null) return "";
    return key === "card"
      ? "Rekomendasi"
      : key === "virtual_accounts"
        ? "Virtual Account"
        : key === "emoney"
          ? "E-Money"
          : key === "credit"
            ? "Cicilan Tanpa Kartu Kredit"
            : key === "credit_card"
              ? "Kartu Kredit"
              : key === "retail"
                ? "Retail"
                : key === "ewallet"
                  ? "E-Wallet"
                  : key === "tempo"
                    ? "Tempo"
                    : "";
  };

  const getInstallmentString = (item) => {
    return item
      ? item.installment_type === 0 && item.installment_plan === "Direct"
        ? "Bayar Penuh"
        : `${toIDR(item.total_summary.total_price_per_month_int)} x ${
            item.installment_details.month
          } bulan`
      : "";
  };

  const changeCollapse = (key) => {
    var temp = cloneDeep(collapseArr);
    temp[key] = !temp[key];
    setCollapseArr(temp);
  };

  const { data: dataPlan, isFetching: isFetchingPlan } = useQuery({
    queryKey: ["plan-credit", subTotal, foundPayment],
    // queryFn: () => getCreditCardPlanPbf(subTotal, selected),
    queryFn: () =>
      getCreditCardPlanPbf({
        payment_channel_id: foundPayment.id ? foundPayment.id : 0,
        grand_total: subTotal,
      }),
    enabled:
      subTotal > 0 &&
      foundPayment !== undefined &&
      selected !== null &&
      // Credit Cards
      (selected === "902" ||
        selected === "008" ||
        // Paylater
        selected === "904" ||
        selected === "112" ||
        selected === "777"),
  });

  const { mutate: mutateUrlPayLater, isLoading: isLoadingUrlPaylater } =
    useMutation({
      mutationFn: getUrlActivatePaylater,
      onSuccess: (data) => {
        window.open(data, "_blank");
      },
    });

  const paymentOptions = useMemo(() => {
    if (dataPaymentMethod) {
      return {
        // Blok tempo sekarang bisa null: apotek yang tidak diberi limit
        // tidak menerimanya sama sekali. Menyebarkan null akan menyisakan
        // baris opsi kosong yang tetap bisa dipilih.
        ...(dataPaymentMethod.tempo
          ? { tempo: [{ ...dataPaymentMethod.tempo, code: "0" }] }
          : {}),
        ...dataPaymentMethod.cbd,
      };
    }

    return {};
  }, [dataPaymentMethod]);

  useEffect(() => {
    if (paymentOptions) {
      var tempCollapseArr = [];
      Object.keys(paymentOptions)?.map((key) => {
        tempCollapseArr.push({ [key]: true });
      });
      setCollapseArr({ tempCollapseArr });
    }
  }, [paymentOptions]);

  useEffect(() => {
    if (dataPlan) setCreditDetail({ ...dataPlan[0], index: 0 });
  }, [dataPlan]);

  return (
    <>
      <LoadingBackdrop isLoading={isLoadingUrlPaylater} />
      {open ? (
        <Modal open={open} onClose={handleClose}>
          <Box
            sx={{
              ...style,
              maxWidth: "90%",
              overflowY: "hidden",
              overflowX: "wrap",
              maxHeight: "80vh",
              padding: 0,
            }}
            className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
          >
            <div className="flex justify-between items-center px-8 py-4">
              <p className="text-[18px]">Metode Pembayaran</p>
              <RxCross1
                className="cursor-pointer hover:text-red-500"
                onClick={handleClose}
              />
            </div>
            <div className="px-8 pb-4 overflow-y-auto overflow-x-hidden max-h-[60vh]">
              <RadioGroup
                value={selected}
                onChange={(e) => {
                  setSelected(e.target.value);
                  if (e.target.value !== "902" || e.target.value !== "008")
                    setCreditDetail(null);
                }}
              >
                {dataPaymentMethod &&
                !isFetchingPaymentMethod &&
                paymentOptions ? (
                  <div>
                    {Object.keys(paymentOptions)
                      ?.filter((key) => key !== "transfer_account")
                      .map((key, i) => {
                        return (
                          <>
                            {key &&
                            paymentOptions[key] &&
                            paymentOptions[key].length > 0 ? (
                              <div className="mb-4">
                                <div
                                  className="flex justify-between items-center text-[16px] cursor-pointer hover:text-gray-300"
                                  onClick={() => changeCollapse(key)}
                                >
                                  <p className="mb-3">
                                    {getPaymentCategory(key)}
                                  </p>
                                  {collapseArr[key] ? (
                                    <FaChevronUp />
                                  ) : (
                                    <FaChevronDown />
                                  )}
                                </div>
                                <Collapse
                                  in={!collapseArr[key]}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  {paymentOptions[key]?.map((item) => {
                                    return (
                                      <div className="px-4 py-2 rounded-md border-2 mb-3">
                                        <div
                                          className={`flex items-center gap-3`}
                                        >
                                          <img
                                            src={item.logo}
                                            className="w-[44px] h-[44px] object-contain"
                                          />
                                          <div className="w-full">
                                            <div className="flex gap-3 items-center">
                                              <div>
                                                <p>
                                                  {item.bank
                                                    ? item.bank
                                                    : item.name}
                                                </p>
                                                {item.bode === "008" &&
                                                selected === "008" ? (
                                                  <p className="mb-2">
                                                    Estimasi total pembayaran:{" "}
                                                    {toIDR(
                                                      dataPlan && creditDetail
                                                        ? dataPlan[
                                                            creditDetail.index
                                                          ]
                                                            .total_price_accumulation_int
                                                        : 0,
                                                    )}
                                                  </p>
                                                ) : null}
                                                <p className="text-gray-400">
                                                  {key === "credit_card" &&
                                                  subTotal < 50000
                                                    ? "Jumlah order harus lebih besar dari Rp50.000"
                                                    : Number(item.id) === 23 &&
                                                        subTotal < 250000
                                                      ? "Jumlah order harus lebih besar dari Rp250.000"
                                                      : ""}
                                                </p>
                                              </div>
                                              {key === "card" ? (
                                                <div
                                                  className={`py-1 px-3 rounded-full w-fit flex items-center gap-2 ${
                                                    item.status === 0
                                                      ? "bg-red-100 text-red-500"
                                                      : "bg-blue-100 text-blue-500"
                                                  } ${
                                                    isLoadingUrlPaylater
                                                      ? "cursor-default bg-gray-300 text-white"
                                                      : item.status === 2
                                                        ? "cursor-pointer hover:bg-gray-300 hover:text-white"
                                                        : "cursor-default"
                                                  }`}
                                                  onClick={() => {
                                                    if (
                                                      item.id === 22 &&
                                                      item.status === 2
                                                    )
                                                      navigate(
                                                        `/purchase/activate-amanah`,
                                                      );
                                                    if (
                                                      item.id === 21 &&
                                                      item.status === 2
                                                    )
                                                      mutateUrlPayLater({
                                                        id: item.id,
                                                      });
                                                  }}
                                                >
                                                  {item.status === 0
                                                    ? "Ditolak"
                                                    : item.status === 1
                                                      ? "Aktif"
                                                      : item.status === 2
                                                        ? "Aktifkan"
                                                        : ""}
                                                  {item.status === 2 ? (
                                                    <FaChevronRight />
                                                  ) : null}
                                                </div>
                                              ) : null}
                                            </div>
                                            {(Number(item.id) === 23 &&
                                              subTotal >= 250000) ||
                                            Number(item.id) === 22 ||
                                            key === "tempo" ? (
                                              <div>
                                                <div className="flex items-center justify-between">
                                                  <p>Tersedia</p>
                                                  <p>
                                                    {toIDR(
                                                      item.limit -
                                                        item.usage_limit,
                                                    )}
                                                  </p>
                                                </div>
                                                <LinearProgress
                                                  variant="determinate"
                                                  value={
                                                    (item.usage_limit /
                                                      item.limit) *
                                                    100
                                                  }
                                                  sx={{ marginY: 1 }}
                                                />
                                                <div className="flex items-center justify-between">
                                                  <p>Jumlah Pemakaian</p>
                                                  <p>
                                                    {toIDR(item.usage_limit)}
                                                  </p>
                                                </div>
                                                <div className="flex items-center justify-between">
                                                  <p>Total Kredit</p>
                                                  <p>{toIDR(item.limit)}</p>
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                          <FormControlLabel
                                            value={item.code}
                                            control={<Radio />}
                                            sx={{ width: "50px" }}
                                            disabled={
                                              ((key === "credit_card" ||
                                                key === "card") &&
                                                subTotal < 50000) ||
                                              (key === "card" &&
                                                item.status !== 1) ||
                                              ((item.id === 23 ||
                                                item.id === 22) &&
                                                (item.limit <= 0 ||
                                                  item.limit < grandTotal)) ||
                                              (Number(item.id) === 23 &&
                                                subTotal < 250000)
                                            }
                                          />
                                        </div>
                                        {key === "tempo" && item.tempo_days ? (
                                          // Lama tempo bukan lagi pilihan:
                                          // admin menetapkannya per apotek, satu
                                          // apotek satu tenor. Dulu ini array
                                          // berisi chip yang bisa diklik.
                                          <div className="mx-[60px]">
                                            <div className="rounded-md py-2 px-3 text-center w-full bg-[#E6E8F3] text-[#071B82] font-semibold cursor-default">
                                              Jatuh tempo {item.tempo_days} hari
                                              setelah pembelian
                                            </div>
                                          </div>
                                        ) : null}
                                        {(key === "card" ||
                                          key === "credit_card") &&
                                        selected === item.code ? (
                                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mx-[60px] gap-2">
                                            {dataPlan && !isFetchingPlan ? (
                                              (selected === "777"
                                                ? dataPlan.slice(0, 1)
                                                : dataPlan
                                              ).map((item, index) => {
                                                // dataPlan.map((item, index) => {
                                                return (
                                                  <div
                                                    className={`rounded-md py-2 px-3 text-center ${
                                                      selected === "008" &&
                                                      index > 0
                                                        ? "cursor-default bg-gray-300 text-white"
                                                        : creditDetail &&
                                                            Number(
                                                              creditDetail.installment_type,
                                                            ) ===
                                                              Number(
                                                                item.installment_type,
                                                              )
                                                          ? "bg-[#071B82] text-white cursor-pointer hover:bg-gray-300"
                                                          : "bg-[#E6E8F3] text-[#071B82] font-semibold cursor-pointer hover:bg-gray-300"
                                                    }`}
                                                    onClick={() => {
                                                      if (
                                                        !(
                                                          selected === "008" &&
                                                          index > 0
                                                        )
                                                      )
                                                        setCreditDetail({
                                                          ...item,
                                                          index: index,
                                                        });
                                                    }}
                                                  >
                                                    {getInstallmentString(item)}
                                                  </div>
                                                );
                                              })
                                            ) : (
                                              <CircularProgress size={20} />
                                            )}
                                          </div>
                                        ) : null}
                                      </div>
                                    );
                                  })}
                                </Collapse>
                              </div>
                            ) : isFetchingPaymentMethod ? (
                              <CircularProgress size={20} />
                            ) : null}
                          </>
                        );
                      })}
                  </div>
                ) : null}
              </RadioGroup>
            </div>
          </Box>
        </Modal>
      ) : null}
    </>
  );
};

export default ModalPaymentOption;
